export default "<div class=\"menu\" (click)=\"presentPopover($event)\"></div>\n";